__turbopack_context__.v({
  "GroupTree": "group-tree-module__K9ub8G__GroupTree",
  "GroupTreeItem": "group-tree-module__K9ub8G__GroupTreeItem",
  "NodeTitle": "group-tree-module__K9ub8G__NodeTitle",
  "selected": "group-tree-module__K9ub8G__selected",
});
